<template>
  <div :class="[b(), className]" :style="styleSizeName" style="position: relative">
    <div :ref="id" :style="styleChartName"></div>
    <div class="gauge-circle" :style="circleStyle">

    </div>
  </div>
</template>

<script>
import create from "../../create";

export default create({
  name: "gauge",
  data() {
    return {
      computedMin: 0,
      computedMax: 100,
      circleStyle: {background: '#fff'}
    }
  },
  computed: {
    gaugeRange() {
      return Math.round(this.computedMax - this.computedMin)
    }
  },
  methods: {
    computeNum(optionData) {
      
      this.computedMin = this.option.min === undefined ? (this.getMin(optionData) || 0) : this.option.min
      this.computedMax = this.option.max === undefined ? (this.getMax(optionData) || 100) : this.option.max
    },
    handlerDimParam(param) {
      // 指标环图结构, 辅助指标显示在柱状图复用，通过assistTip字段加一层控制
      param.componentType = this.option.assistTip ? 'indexRingGraph' : undefined;
      return param
    },
    updateChart() {
      let optionData = this.deepClone(this.dataChart);
      if (this.isDataCenter) {
        let dimentionData = this.getDimentionOption();
        if (dimentionData.categories[0]) {
          let tmp = dimentionData.categories.map((el) => {
            return {
              name: el
            }
          })
          dimentionData.series[0].data.forEach((el, index) => {
            tmp[index].value = el.value
          })
          optionData = tmp
        } else {
          optionData = dimentionData.series.map((i) => {
            return {
              ...i,
              data: i.data.map((item) => {
                return item.value
              }),
              value: i.data.map((item) => {
                return item.value
              })[0]
            }
          })
        }
      }

      this.computeNum(optionData)
      if (!this.option.intervalArray) {
        this.option.intervalArray = [{
          intervalValue: 30,
          intervalName: 'test1'
        }, {
          intervalValue: 70,
          intervalName: 'test2'
        }, {
          intervalValue: 100,
          intervalName: 'test3'
        }]
      }
      const option = {
        title: this.getOptionTitle(),
        grid: this.getOptionGrid(),
        legend: this.getOptionLegend(this.getLegend(this.option.intervalArray)),
        xAxis: [   //这里有很多的show，必须都设置成不显示
          {
            axisLine: {
              show: false
            },
          }
        ],
        yAxis: [ //这里有很多的show，必须都设置成不显示
          {
            axisLine: {
              show: false
            },
          }
        ],
        series: [
          {
            name: "业务指标",
            type: "gauge",
            max: this.option.maxAuto ? this.getMax(optionData) : this.computedMax,
            min: this.option.minAuto ? this.getMin(optionData) : this.computedMin,
            splitNumber: this.option.intervalAuto === 'auto' ? 10 : this.option.intervalAuto === 'range' ? this.gaugeRange : (this.option.interval || 10),
            startAngle: this.option.startAngle || 225,
            endAngle: this.option.endAngle || -45,
            pointer: {
              width: this.option.pointerWidth || '4',
              length: this.option.pointerLength || "40%",
              itemStyle: {
                color: 'auto'
              }
            },
            axisLine: {
              lineStyle: {
                width: this.option.lineSize || 6,
                color: this.getIntervalColor(optionData)
              },
              // roundCap: false,
            },
            axisLabel: {
              show: this.validData(this.option.axisLabelShow, true),
              fontSize: this.option.axisLabelFontSize || 25,
              color: this.option.axisLabelColor,
              distance: this.option.axisLabelDistance || 14,
              formatter: (value) => {
                if (this.option.intervalAuto === 'range' && this.option?.intervalArray?.length) {
                  if (value === this.computedMin || value === this.computedMax || this.option.intervalArray.find(_el => _el.intervalValue === value)) {
                    return value
                  } else {
                    return ''
                  }
                } else {
                  return value
                }
              }
            },
            axisTick: {
              show: this.validData(this.option.axisTickShow, true),
              lineStyle: {
                color: this.option.lineColor || "#CCCCCC"
              }
            },
            splitLine: {
              show: this.validData(this.option.splitLineShow, true),
              lineStyle: {
                color: "#999999"
              }
            },
            detail: {
              show: false,
            },
            title: {
              show: this.validData(this.option.labelShow, true),
              color: this.option.labelColor,
              fontSize: this.option.labelFontSize || 20,
              fontWeight: 'lighter',
              padding: [8, 10],
              width: this.option.labelWidth || 'fit-content',
              borderRadius: this.option.labelRadius ? [this.option.labelRadius, this.option.labelRadius, this.option.labelRadius, this.option.labelRadius] : 5,
            },
            data: this.setTitleAndDetailPosition(optionData)
          },
        ]
      };
      this.getLegendBar(option, this.option.intervalArray)
      this.myChart.resize();
      this.myChart.setOption(this.echartsOptionHandler(option), true);
    },
    getLegend(data = []) {
      return data.map((el, index) => {
        return {name: el.intervalName || `test${index}`}
      })
    },
    getIntervalColor(data) {
      if (this.option.barColor || (this.themeCfg.barColor && this.themeCfg.barColor.length)) {
        this.circleStyle.background = this.getColor(0)
        return this.option.intervalArray.map((el, index) => {
          return [(el.intervalValue - (this.option.minAuto ? this.getMin(data) : (this.option.min || (this.getMin(data) || 0)))) / ((this.option.maxAuto ? this.getMax(data) : (this.option.max || (this.getMax(data) || 100))) - (this.option.minAuto ? this.getMin(data) : (this.option.min || (this.getMin(data) || 0)))), this.getColor(index)]
        })
      } else {
        const defaultColor = ['rgb(113, 210, 223)', 'rgb(76, 165, 255)', 'rgb(255, 186, 111)']
        this.circleStyle.background = 'rgb(113, 210, 223)'
        return this.option.intervalArray.map((el, index) => {
          return [(el.intervalValue - (this.option.minAuto ? this.getMin(data) : (this.option.min || (this.getMin(data) || 0)))) / ((this.option.maxAuto ? this.getMax(data) : (this.option.max || (this.getMax(data) || 100))) - (this.option.minAuto ? this.getMin(data) : (this.option.min || (this.getMin(data) || 0)))), defaultColor[index]]
        })
      }
    },
    getLegendBar(option, data = []) {
      data.forEach((el, index) => {
        option.series.push({
          name: el.intervalName || `test${index}`,
          type: 'bar',
          colorBy: 'data',
          itemStyle: {
            normal: {
              color: this.getColor(index),
            }
          }
        })
      });
    },
    getMax(data) {
      let result = []
      data.forEach((el) => {
        if (el?.data?.length) {
          result.push(Math.max(...el.data.map((el) => {
            return Number.parseInt(this.handleInvalidData(el))
          })))
        }
      })
      if (result.length) {
        return Math.max(...result)
      } else {
        return 100
      }
    },
    getMin(data) {
      let result = []
      data.forEach((el) => {
        if (el?.data?.length) {
          result.push(Math.min(...el.data.map((el) => {
            return Number.parseInt(this.handleInvalidData(el))
          })))
        }
      })
      if (result.length) {
        return Math.min(...result)
      } else {
        return 0
      }
    },
    setTitleAndDetailPosition(data = []) {
      let optionColor = []
      if (this.option.barColor && this.option.barColor?.length) {
        optionColor = this.option.barColor.map(item => item.color1)
      } else if (this.themeCfg.barColor && this.themeCfg.barColor.length) {
        optionColor = this.themeCfg.barColor.map(item => item.color1)
      }
      const length = data.length;
      const interval = length % 2 == 0 ? 0.5 : 1;
      const start = -Math.floor(length / 2) * interval;
      data = data.map((el, index) => {
        const ratio = start + index
        const leftOffset = ratio * (this.option.leftOffset || 70)
        const topOffset = this.option.topOffset || 80
        const v = this.handleInvalidData(el.value || el.data[0])
        const name = `${el.name} ${v} ${this.option.unit || ''}`
        const width = (el.name.length + `${v}`.length / 2) * (this.option.labelFontSize || 20) + 20
        const height = (this.option.labelFontSize || 20) + 8

        return {
          ...el,
          value: v,
          name: `${el.name} ${v} ${this.option.unit || ''}`,
          title: {
            offsetCenter: [`${leftOffset}%`, `${topOffset}%`],
            width,
            height,
            backgroundColor: optionColor[index]
          },
          detail: {
            offsetCenter: [`${leftOffset}%`, `${topOffset + 25}%`],
            width,
            height,
            backgroundColor: optionColor[index]
          },
        }
      })
      return data
    },
    handleInvalidData(data) {
      if (data) {
        data = Number(data)
        if (isFinite(data)) {
          return data
        }
      }
      return 0
    }
  }
});
</script>
<style lang="scss" scoped>
.gauge-circle {
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  left: calc(50% - 7px);
  top: calc(50% - 8px);

  &:after {
    display: block;
    content: " ";
    position: absolute;
    width: 8px;
    height: 8px;
    background-color: #fff;
    border-radius: 100%;
    left: calc(50% - 4px);
    top: calc(50% - 4px);
  }
}
</style>
